var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKritiqueLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 877.91 199.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7705bc;}.cls-2{fill:#fc0b7a;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M587.09,189.55l-17-20.51a69.92,69.92,0,1,0-24.26,18.42c11,10.53,26,12.5,36.49,12.34A6.26,6.26,0,0,0,587.09,189.55Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "64.86 117.87 120.39 56.37 77.96 56.37 33.46 108.46 33.46 1.63 0 1.63 0 188.5 33.46 188.5 33.46 128.49 85.55 188.5 125.91 188.5 125.91 185.12 64.86 117.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 250.27,
    y: 56.06,
    width: 32.77,
    height: 132.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 266.65,
    cy: 20.06,
    r: 20.06
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 402.54,
    y: 56.06,
    width: 32.77,
    height: 132.44
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 418.93,
    cy: 20.06,
    r: 20.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M385.83,157.07C350.19,171.92,353,138.7,353,138.7V86.05h36.64V57H353v-37l-32.76,3.05V57H295.64v29h24.57V138.7c0,75.88,74.53,45.64,74.53,45.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.14,53.59c-20.89,0-31.38,10.28-36,17l-2-13.58H138.94V188.5h33.55V115.75S172.77,92,195.73,87.4s32.67,7.29,32.67,7.29L243.79,66.6S235.14,53.59,208.14,53.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M694.88,57.24v72.12s-4,33.37-35.52,31.93-29.42-34.59-29.42-34.59V57.24H596.57V126.7s-2.87,65.09,57.76,65.09c20.12,0,33.22-9.3,41.71-20.66L698.83,190h29.06V57.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M873.56,92c-9.83-23.91-30.4-39.39-66-39.39,0,0-51.77.5-64.22,47-12.2,45.56,10,87.54,57.76,92.2S869.25,171,869.25,171l-21.16-21.17s-10.77,13.28-36.24,13.28-38-19-38-28.35H877.15S880.38,108.55,873.56,92Zm-98.67,15.14c0-4.66,7.53-25.11,37.67-25.11,28.71,0,33,25.11,33,25.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKritiqueLogo);
export default __webpack_public_path__ + "static/media/kritique-logo.2583e168b712d05b89897f6cd70fcb63.svg";
export { ForwardRef as ReactComponent };